import clsx from 'clsx';
import { useBranding } from '@/outlets/branding-outlet';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';
import styles from './id-verification-announcement-banner.module.css';
import { useTranslation } from '@/contexts/i18n-context';

export function IdVerificationAnnouncementBanner() {
  const { hasIdVerification } = useBranding();
  const { t } = useTranslation();

  if (!hasIdVerification) {
    return null;
  }

  return (
    <div className={styles.banner} data-testid="id-verification-announcement-banner">
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <MaterialSymbolIcon name="verified_user" className={styles.icon} />
        </div>
        <div className={styles.text}>
          <p className={clsx('body-3', 'semibold')}>
            {t('dashboard.idVerificationAnnouncementBanner.title')}
          </p>
          <p className={clsx('body-3', styles.body)}>
            {t('dashboard.idVerificationAnnouncementBanner.body')}
          </p>
        </div>
      </div>
    </div>
  );
}
